module.exports = __webpack_public_path__ + "img/ywcq_1.47e11bd3.jpg";